<div class="fc-signup-verify-email">
    <div class="fc-signup-verify-email-frame">
        <div class="fc-signup-verify-email-frame-body">
            <div class="fc-signup-verify-email-frame-body-header">
                {{ 'SIGNUP.EMAIL_VERIFICATION.HEADER' | translate }}
            </div>
            <div class="fc-signup-verify-email-frame-body-description">
                {{ 'SIGNUP.EMAIL_VERIFICATION.DESCRIPTION' | translate }} {{ userEmail$ | async }}
            </div>

            <div class="fc-signup-verify-email-frame-body-button">
                <button
                    fcp-filled-button
                    data-e2e-hook="signup-verify-email-resend-button"
                    [disabled]="isResendInFlight || isResendDisabledForSession"
                    (click)="resendVerificationEmail()"
                >
                    <fcp-icon-svg [icon]="iconNameMap.Send" [size]="fcpIconSVGSize.Small"></fcp-icon-svg>
                    {{ 'SIGNUP.EMAIL_VERIFICATION.BUTTON.LABEL' | translate }}
                </button>
                <div *ngIf="showResendError" class="fc-signup-verify-email-frame-body-error">
                    {{ 'SIGNUP.EMAIL_VERIFICATION.ERROR' | translate }}
                </div>
            </div>
            <div class="fc-signup-verify-email-frame-body-contact">
                {{ 'SIGNUP.EMAIL_VERIFICATION.INFO.CONTACT' | translate }}
                <div class="fc-signup-verify-email-frame-body-contact-email">{{ supportEmail }}</div>
            </div>
        </div>
    </div>
</div>
